export const environment = {
  production: true,
  apiBaseUrl: 'https://stage.api.doctainium.com/api/',
  baseUrl: 'https://stage.api.doctainium.com/',
  webUrl: 'https://stage.doctainium.com/',
  session: 'pdf_pub_live_Evp8h3RgZ6KxAzsXoVofeRcCowgA5ZS1KsDSD6FRxaD',
  //apiBaseUrl: 'https://doctaniumapi-stage.aixsol.com/api/',
  //baseUrl: 'https://doctaniumapi-stage.aixsol.com/',
  //webUrl: 'https://doctanium-stage.aixsol.com/',
  // apiBaseUrl: 'https://sites.sunbeltsol.com/inceptionpublicportal/service/api/',
  // baseUrl: 'https://sites.sunbeltsol.com/inceptionpublicportal/service/',
  // webUrl: 'https://doctanium-stage-ui.azurewebsites.net/',
  successMessageLifeTime: 5000,
  warningMessageLifeTime: 5000,
  errorMessageLifeTime: 10000,
  // In Minutes
  sessionTimeOut: 60,
  messageLifeSpan: 5000
};
